import Vue from 'vue'

Vue.mixin({
  filters: {
    capitalize(str) {
      if (!str || str.length <= 1) return str
      return str.charAt(0).toUpperCase() + str.slice(1)
    },

    price(n) {
      const formatNumber = v =>
        v.replace(/\D/g, '').replace(/\B(?=(\d{3})+(?!\d))/g, ',')
      let value = (n || '0').toString()
      let decimalPos = value.indexOf('.')
      value = value.replace(/^\$0+/, '')
      if (decimalPos >= 0) {
        let decimal = value.substring(decimalPos).substring(0, 3)
        return `${formatNumber(value.substring(0, decimalPos))}${
          decimal.length >= 3 ? decimal : decimal + '0'
        }`
      } else {
        return `${formatNumber(value)}`
      }
    }
  }
})
